import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

import AbTestMetricCard from './AbTestMetricCard';
import { useGetAbTestConversationChartsQuery } from 'src/services/agent-ab-test/agentAbTestApi';

interface AbTestConversationMetricCardsProps {
  abTestId: string;
  endTimestamp: number;
  startTimestamp: number;
}

const AbTestConversationMetricCards = ({
  abTestId,
  endTimestamp,
  startTimestamp,
}: AbTestConversationMetricCardsProps) => {
  const { data: charts, isLoading } =
    useGetAbTestConversationChartsQuery(abTestId);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'grid',
          gap: '16px',
          gridTemplateColumns: 'repeat(3, 1fr)',
          marginBottom: '24px',
        }}
      >
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton
            height={100}
            key={index}
            sx={{ borderRadius: '8px' }}
            variant='rectangular'
          />
        ))}
      </Box>
    );
  }

  if (!charts?.length) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gap: '16px',
        gridTemplateColumns: 'repeat(3, 1fr)',
        marginBottom: '24px',
      }}
    >
      {charts.map(chart => (
        <AbTestMetricCard
          chart={chart}
          endTimestamp={endTimestamp}
          key={chart.chart_id}
          startTimestamp={startTimestamp}
        />
      ))}
    </Box>
  );
};

export default AbTestConversationMetricCards;
